import { useEffect } from "react";
import { isInApp } from './useInApp';

interface AppShareParams {
  title?: string, // 弹窗title 默认分享至
  imageUrl?: string, // 分享图片时 分享的图片内容 url 类型
  copyUrl?: string, // 复制链接 设置需要复制的内容
  shareMiniProgramPath?: string, // 分享小程序路径 /paths/home 只能分享绿喵小程序
  shareWebpagePath?: string, // 分享h5路径 https://test.com/test
  shareTitle?: string, // 分享标题 在小程序和h5生效
  shareDesc?: string, // 分享描述 在h5生效
  showGoHomeButton?: boolean, // 是否展示返回首页按钮 默认false
  thumbUrl?: string, // 分享小程序 或者 分享h5 时的 缩略图
  showShareFriend?: boolean, // 是否展示 分享微信按钮 默认true
  showShareCircle?: boolean, // 是否展示 分享朋友圈按钮 默认true
  showReFresh?: boolean, // 是否展示刷新按钮
}

// 初始化 设置右上角的分享按钮
export const useShare = (info: Array<AppShareParams>) => {
  useEffect(() => {
    const setInfo = () => {
      if (isInApp()) {
        if (!!info) {
          window?.flutter_inappwebview?.callHandler?.('setShowShare', ...info);
        } else {
          window?.flutter_inappwebview?.callHandler?.('setHideShare');
        }
      }
    }
    if (isInApp()) {
      setInfo();
    }
    window.addEventListener('flutterInAppWebViewPlatformReady', setInfo, false);
    return () => {
      if (!!window?.flutter_inappwebview?.callHandler) {
        window?.flutter_inappwebview?.callHandler?.('setHideShare');
      }
      window.removeEventListener('flutterInAppWebViewPlatformReady', setInfo, false);
    };
  }, info);
}

//  设置右上角的分享按钮
export const setShare = (info: Array<AppShareParams>) => {
  const setInfo = () => {
    if (isInApp() && !!info) {
      window?.flutter_inappwebview?.callHandler?.('setShowShare', ...info);
    }
  }
  setInfo();
}

//  移除右上角的分享按钮
export const hideShare = () => {
  window?.flutter_inappwebview?.callHandler?.('setHideShare');
}

// 直接打开分享弹窗
export const openShareModal = (info: AppShareParams) => {
  const setInfo = () => {
    if (isInApp() && !!info) {
      window?.flutter_inappwebview?.callHandler?.('openShareModal', info);
    }
  }
  setInfo();
}
